module.exports = __webpack_public_path__ + "std/img/log_bg.6867929.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/common/log_bg.jpg
// module id = LtLu
// module chunks = 0 1